module.exports = "../../../../platform/assets/pageMainIcon/simple_.svg";